import { render, staticRenderFns } from "./LoadRateItem.vue?vue&type=template&id=55aeaa47&scoped=true&"
import script from "./LoadRateItem.vue?vue&type=script&lang=js&"
export * from "./LoadRateItem.vue?vue&type=script&lang=js&"
import style0 from "./LoadRateItem.vue?vue&type=style&index=0&id=55aeaa47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aeaa47",
  null
  
)

export default component.exports